import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HeadingComponent } from '@uc/shared/ui';
import { FeaturedClearingVisitWebsite } from '@uc/web/shared/data-models';
import { ClearingVisitWebsiteBtnComponent } from '@web/shared/ui';

@Component({
	selector: 'uc-clearing-course-headings',
	templateUrl: './clearing-course-headings.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [HeadingComponent, ClearingVisitWebsiteBtnComponent],
})
export class ClearingCourseHeadingsComponent {
	courseSummary = input.required<string>();
	courseName = input.required<string>();
	isFeatured = input.required<FeaturedClearingVisitWebsite>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	externalUrl = input.required<string | undefined>();
	clearingUsp = input.required<string>();
	clearingCourseEnabled = input.required<boolean>();
	cleSearchOrderPosition = input.required<number>();
	privacyPolicyUrl = input.required<string | null>();
}
